// Access settings of a test series: Free, or Premium with a price and an access duration. These
// mirror the backend rules (a PREMIUM series needs price > 0 and durationDays > 0), so the admin
// form can block a save the API would reject.

export const ACCESS_TYPES = ["FREE", "PREMIUM"];

// Backend storage limits: price is NUMERIC(10,2), duration is kept sane (100 years).
export const MAX_PRICE = 99999999.99;
export const MAX_DURATION_DAYS = 36500;

// -> { price?: string, durationDays?: string }; an empty object means the access settings are valid.
export function validateSeriesAccess({ accessType, price, durationDays }) {
  if (accessType !== "PREMIUM") return {};
  const errors = {};
  if (!(Number(price) > 0)) {
    errors.price = "Enter a price greater than 0";
  } else if (!/^\d+(\.\d{1,2})?$/.test(String(price).trim()) || Number(price) > MAX_PRICE) {
    errors.price = "Price can have at most 2 decimals and cannot exceed 99,999,999.99";
  }
  const days = Number(durationDays);
  if (!(Number.isInteger(days) && days >= 1)) {
    errors.durationDays = "Enter a whole number of days (1 or more)";
  } else if (days > MAX_DURATION_DAYS) {
    errors.durationDays = "Access duration cannot exceed 36,500 days";
  }
  return errors;
}

// The access part of a create/update payload. A free series sends no price or duration.
export function buildAccessPayload({ accessType, price, durationDays }) {
  if (accessType !== "PREMIUM") return { accessType: "FREE" };
  return { accessType: "PREMIUM", price: Number(price), durationDays: Number(durationDays) };
}

export function formatSeriesPrice(series) {
  if (series?.accessType !== "PREMIUM" || series.price == null) return "—";
  return `₹${Number(series.price).toLocaleString("en-IN")}`;
}

// How long a purchase of a premium series gives access, e.g. "30 days". A free series has no duration.
export function formatSeriesDuration(series) {
  if (series?.accessType !== "PREMIUM" || series.durationDays == null) return "—";
  const days = Number(series.durationDays);
  return `${days} day${days === 1 ? "" : "s"}`;
}
